import { IconProps } from '../../Icon.types';

export const Policy3DIcon = ({ width, height, color }: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_i_3982_59694)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.4181 3.6001H21.5992C19.6647 3.60146 18.0822 3.61376 16.7755 3.72052C15.2635 3.84406 13.963 4.10322 12.7685 4.71183C10.8493 5.68974 9.28886 7.25014 8.31095 9.16939C7.70234 10.3639 7.44318 11.6644 7.31964 13.1764C7.19919 14.6506 7.1992 16.476 7.19922 18.7618V29.2384C7.1992 31.5242 7.19919 33.3495 7.31964 34.8238C7.44318 36.3358 7.70234 37.6363 8.31095 38.8308C9.28886 40.75 10.8493 42.3105 12.7685 43.2884C13.963 43.897 15.2635 44.1561 16.7755 44.2797C18.2497 44.4001 20.075 44.4001 22.3607 44.4001H25.6375C27.9233 44.4001 29.7487 44.4001 31.2229 44.2797C32.7349 44.1561 34.0354 43.897 35.2299 43.2884C37.1492 42.3105 38.7096 40.75 39.6875 38.8308C40.2961 37.6363 40.5553 36.3358 40.6788 34.8238C40.7992 33.3496 40.7992 31.5243 40.7992 29.2384V19.9813C40.7992 18.8072 40.7992 18.2202 40.6666 17.6678C40.549 17.178 40.3551 16.7098 40.0919 16.2803C39.795 15.7959 39.38 15.3808 38.5498 14.5507L29.8486 5.84952C29.0185 5.01937 28.6034 4.60426 28.119 4.30742C27.6895 4.04425 27.2213 3.85031 26.7315 3.73272C26.1791 3.6001 25.5921 3.6001 24.4181 3.6001ZM37.1992 29.1601C37.1992 31.542 37.1978 33.2202 37.0908 34.5306C36.9854 35.82 36.7868 36.594 36.4799 37.1964C35.8471 38.4383 34.8374 39.448 33.5956 40.0807C32.9932 40.3877 32.2191 40.5863 30.9297 40.6916C29.6193 40.7987 27.9411 40.8001 25.5592 40.8001H22.4392C20.0573 40.8001 18.3791 40.7987 17.0687 40.6916C15.7793 40.5863 15.0053 40.3877 14.4029 40.0807C13.161 39.448 12.1513 38.4383 11.5186 37.1964C11.2116 36.594 11.013 35.82 10.9077 34.5306C10.8006 33.2202 10.7992 31.542 10.7992 29.1601V18.8401C10.7992 16.4582 10.8006 14.78 10.9077 13.4696C11.013 12.1802 11.2116 11.4061 11.5186 10.8038C12.1513 9.56189 13.161 8.55222 14.4029 7.91946C15.0053 7.61252 15.7793 7.41391 17.0687 7.30856C18.3791 7.2015 20.0573 7.2001 22.4392 7.2001H23.9992V12.8399C23.9992 13.8207 23.9992 14.6668 24.0579 15.3629C24.1199 16.0981 24.257 16.8284 24.6269 17.5269C25.1334 18.4836 25.9157 19.2659 26.8724 19.7724C27.571 20.1423 28.3012 20.2794 29.0364 20.3414C29.7325 20.4002 30.5787 20.4001 31.5595 20.4001L37.1992 20.4001V29.1601ZM35.7081 16.8001L27.5992 8.69127V12.7681C27.5992 13.8409 27.6007 14.5336 27.6451 15.0602C27.6877 15.5647 27.7599 15.7506 27.8084 15.8424C27.9773 16.1613 28.2381 16.422 28.5569 16.5909C28.6487 16.6395 28.8346 16.7116 29.3391 16.7542C29.8657 16.7986 30.5584 16.8001 31.6312 16.8001H35.7081Z"
          fill={color}
        />
      </g>
      <defs>
        <filter
          id="filter0_i_3982_59694"
          x="6.19922"
          y="3.6001"
          width="34.5996"
          height="41.8"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1" dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.211765 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_3982_59694"
          />
        </filter>
      </defs>
    </svg>
  );
};
